export default {"src":"/_next/static/media/bg-circle-left.45dacb14.svg","height":1022,"width":780};